import { createFileRoute } from '@tanstack/react-router'
import { ExpensePage } from '../../../components/ExpensePage'

export const Route = createFileRoute('/$org/expenses/$expenseUid')({
  component: ExpenseDetail,
})

function ExpenseDetail() {
  return <ExpensePage />
}
